import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, Dropdown, Badge, Button, } from 'react-bootstrap';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import "../../../../assets/css/handler_uld/handler_uld.css";

import Filter from '../../../../assets/images/ucm_dashboard/filter.svg';

const Dashboard = () => {
  const now = 60;
  return (
    <>
      <div className="mb-3 nestedtabs rounded minh scmdash d-flex justify-content-between">
        <div className='d-flex'>
          <button className="condition" variant="link">
            <span> <FontAwesomeIcon icon={faPlus} /> Create SCM</span>
          </button>
          <div class="left-controls">
            <select class="form-select warehouse-select">
              <option selected>Warehouse</option>
              <option>Warehouse B</option>
              <option>Warehouse C</option>
            </select>
          </div>
          {/* <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic" className='adduld'>
              <FontAwesomeIcon icon={faPlus} /> Add ULD <FontAwesomeIcon icon={faChevronDown} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item href="/ULDControl/AddStock">New Stock</Dropdown.Item>
              <Dropdown.Item href="/ULDControl/NewCharter">New Charter</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
          {/* <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
              <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'In Operation')}>In Operation</Dropdown.Item>
              <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Repair In')}>Repair In</Dropdown.Item>
              <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Repair Out')}>Repair Out</Dropdown.Item>
              <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'In Reserve')}>In Reserve</Dropdown.Item>
              <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Lease Out')}>Lease Out</Dropdown.Item>
              <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'SCM')}>SCM</Dropdown.Item>
              <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Missing')}>Missing</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
        </div>
        <div>
          <div className="right-controls">
            <button className="filter-btn">
              <img src={Filter} alt="" /> Filter
            </button>
          </div>
        </div>
      </div>
      <div>

        <div className="scm_list opnpln-box mt-3 d-flex align-items-center">
          <div className="airline_nm">
            <h6>Airline Name</h6>
            <p>Demo Airline</p>
          </div>
          <div className="owner_code">
            <h6>Owner Code</h6>
            <p>ZZZ</p>
          </div>
          <div className="status">
            <h6>Status</h6>
            <p className="proggrss">In Progress</p>
          </div>
          <div className="progress_dv">
            <h6 className="d-flex align-items-center">Progress <span className="ms-auto">8/22</span></h6>
            <ProgressBar now={now} label={`${now}%`} visuallyHidden />
          </div>
          <div className="warehouse">
            <h6>Warehouse</h6>
            <p>AMS</p>
          </div>
          <div className='conbtn'>
            <Button className="scm_status_btn">Continue</Button>
          </div>
        </div>
        <div className="scm_list opnpln-box mt-3 d-flex justify-content-between align-items-center">
          <div className="airline_nm">
            <h6>Airline Name</h6>
            <p>Demo Airline</p>
          </div>
          <div className="owner_code">
            <h6>Owner Code</h6>
            <p>ZZZ</p>
          </div>
          <div className="status">
            <h6>Status</h6>
            <p className="scm_completed">Completed</p>
          </div>
          <div className="progress_dv">
            <h6 className="d-flex align-items-center">Progress <span className="ms-auto">30/30</span></h6>
            <ProgressBar now={now} label={`${now}%`} visuallyHidden />
          </div>
          <div className="warehouse">
            <h6>Warehouse</h6>
            <p>AMS</p>
          </div>
          <div className='conbtn'>
            <Button className="scm_status_btn_cmplt">Start</Button>
          </div>
        </div>
        <div className="scm_list opnpln-box mt-3 d-flex justify-content-between align-items-center">
          <div className="airline_nm">
            <h6>Airline Name</h6>
            <p>Demo Airline</p>
          </div>
          <div className="owner_code">
            <h6>Owner Code</h6>
            <p>ZZZ</p>
          </div>
          <div className="status">
            <h6>Status</h6>
            <p className="overdue">Overdue</p>
          </div>
          <div className="progress_dv">
            <h6 className="d-flex align-items-center">Progress <span className="ms-auto">24/50</span></h6>
            <ProgressBar now={now} label={`${now}%`} visuallyHidden />
          </div>
          <div className="warehouse">
            <h6>Warehouse</h6>
            <p>AMS</p>
          </div>
          <div className='conbtn'>
            <Button className="scm_status_btn">Continue</Button>
          </div>
        </div>

      </div>
    </>
  )
}

export default Dashboard